import { 
    GET_PROFILE,
    GET_PROFILES,
    GET_PROFILE_REQUEST,
    DELETE_PROFILE,
    CREATE_PROFILE,
    CLEAR_PROFILE,
    GET_PACKAGES_MEMBERSHIPS,
    CLEAR_NEW_PROFILE_CREATED
} from '../actions/types';

const initialState = {
    profiles : [],
    profile : {},
    loading : false,
    packages: [],
    memberships: [],
    newProfileCreated: false
}


export default (state = initialState, { type, payload }) => {    
    switch (type) {
        case GET_PROFILE:
            return {
                ...state,
                profile: payload,
                loading: false 
            };

        case CREATE_PROFILE:
            return {
                ...state,
                profile: payload,
                loading: false,
                newProfileCreated: true
            };

        case CLEAR_PROFILE:
            return {
                ...state,
                profile: {},
                loading: false
            };
        case CLEAR_NEW_PROFILE_CREATED:
            return {
                ...state,
                newProfileCreated: false
            };
            
        case GET_PROFILES:
            return {
                ...state,
                profiles: payload,
                loading: false
            };
        
        case GET_PACKAGES_MEMBERSHIPS:
            return {
                ...state,
                packages: payload.packages || [],
                memberships: payload.memberships || [],
                loading: false
            };
        
        case GET_PROFILE_REQUEST:
            return { 
                ...state,
                loading: payload
            };
        // profiles: state.profiles.filter(profile => profile._id !== payload),
        case DELETE_PROFILE:
            return { 
                ...state,
                profiles : payload,                
                loading: false
            };

        default:
            return state
    }
};